import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { AiFilterChip } from './AiFilterChip/AiFilterChip';
import { currentValue, isExcludeMode, namesActorToken, valueLabelFor } from './modifiedByLabel';
export const modifiedByChipUnit = (param)=>{
    let { predicate, testId, texts, onChange, biPrefix, lockSentinelActors } = param;
    var _ref;
    const isExclude = isExcludeMode(predicate);
    const actors = (_ref = isExclude ? predicate.nin : predicate.in) !== null && _ref !== void 0 ? _ref : [];
    const isLocked = lockSentinelActors && namesActorToken(predicate);
    const actorsLabel = valueLabelFor(predicate, texts.me, texts.anchorAi);
    const applyActor = (input)=>{
        if (input === '') return onChange(undefined);
        onChange(isExclude ? {
            nin: [
                input
            ]
        } : {
            in: [
                input
            ]
        });
    };
    return {
        key: 'lastModifiedBy',
        node: /*#__PURE__*/ _jsx(AiFilterChip, {
            mode: "text",
            testId: testId,
            fieldLabel: texts.label,
            value: currentValue(predicate),
            valueLabel: isExclude ? "≠".concat(actorsLabel) : actorsLabel,
            editable: actors.length <= 1 && !isLocked,
            onApply: applyActor,
            onRemove: ()=>onChange(undefined),
            biPrefix: biPrefix,
            texts: {
                apply: texts.apply
            }
        })
    };
};
